module.exports = __webpack_public_path__ + "img/payments.a89a6b6.png";